import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Dropdown } from '@bingads-webui-react/fabric-with-signal';

const languageAll = 'All';

export function MultiLanguageSelector(props) {
  const {
    languages,
    selectedLanguages,
    onSelectedLanguagesChanged,
    ariaLabel,
  } = props;

  const isSelectAll = useMemo(() => selectedLanguages.length === 1
  && selectedLanguages[0] === languageAll, [selectedLanguages]);

  const options = _.map(languages, language => (
    {
      key: language.key,
      text: language.text,
      disabled: isSelectAll && language.key !== languageAll,
    }
  ));

  const dropdownStyles = { dropdown: { width: 320 } };

  return (
    <div className={classNames('multi-language-selector-container')}>
      <Dropdown
        className="multi-language-selector-dropdown"
        placeholder="Select languages"
        selectedKeys={selectedLanguages}
        onChange={onSelectedLanguagesChanged}
        multiSelect
        options={options}
        styles={dropdownStyles}
        ariaLabel={ariaLabel}
      />
    </div>
  );
}

MultiLanguageSelector.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string),
  selectedLanguages: PropTypes.arrayOf(PropTypes.string),
  onSelectedLanguagesChanged: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

MultiLanguageSelector.defaultProps = {
  languages: [],
  selectedLanguages: [],
  ariaLabel: undefined,
};
